module.exports = __webpack_public_path__ + "img/gywm-6.b9adb130.jpg";